import graphql__52db0871c89a73a46e15 from "./__generated__/AppDangerSectionQuery.graphql.ts";import { Heading } from '@portal/components'
import { graphql } from 'babel-plugin-relay/macro'
import { useAppToDatabaseRename } from 'components/hooks'
import { TenantContext } from 'components/tenant'
import { useContext, useEffect } from 'react'
import {
  PreloadedQuery,
  usePreloadedQuery,
  useQueryLoader,
} from 'react-relay/hooks'
import { useAppManagementContext } from 'scenes/appManagement/context'

import { AppDangerSectionQuery } from './__generated__/AppDangerSectionQuery.graphql'
import AppVisibilitySection from './AppVisibilitySection'
import DeleteAppSection from './DeleteAppSection'
import TransferAppSection from './TransferAppSection'

export const query = graphql__52db0871c89a73a46e15

/** Section with the controls required for deleting an app */
export default function AppDangerSectionContainer() {
  const { appId } = useAppManagementContext()
  const [queryRef, loadQuery] = useQueryLoader<AppDangerSectionQuery>(query)

  useEffect(() => {
    loadQuery({ appId }, { fetchPolicy: 'store-and-network' })
  }, [appId, loadQuery])

  if (!queryRef) {
    return null
  }

  return <AppDangerSection queryRef={queryRef} />
}

type Props = {
  queryRef: PreloadedQuery<AppDangerSectionQuery>
}

function AppDangerSection({ queryRef }: Props) {
  const {
    viewer: { appById: app, me },
  } = usePreloadedQuery<AppDangerSectionQuery>(query, queryRef)
  const { tenant } = useContext(TenantContext)
  const { databaseText } = useAppToDatabaseRename()

  const appIsInOrganization = !!tenant
  const viewerHasOwnerPrivileges = !!me?.isSuperAdmin || !!app?.viewerOwnsApp

  const isActionPossible =
    viewerHasOwnerPrivileges ||
    !!app?.viewerCanTransfer ||
    !!app?.transferRequestDestination ||
    !!app?.viewerCanDelete

  if (!app || !isActionPossible) {
    return null
  }

  return (
    <div className="flex flex-col gap-12">
      <div>
        <Heading level={2}>Danger zone</Heading>
        <p className="font-sans text-foreground-subtle">
          Delete your {databaseText} entirely or transfer it to another person
          or organization. Be cautious when taking action here.
        </p>
      </div>

      {viewerHasOwnerPrivileges && appIsInOrganization && (
        <AppVisibilitySection />
      )}
      {(app.viewerCanTransfer || !!app.transferRequestDestination) && (
        <TransferAppSection />
      )}
      {app.viewerCanDelete && <DeleteAppSection />}
    </div>
  )
}
